import { FEATURE_ACCESS_RULES } from '../modules/accounts/utils/accessRulesConfig';
import { isFeatureAllowed } from '../modules/accounts/utils/isFeatureAllowedForICPAccount';
import { useAccount, useConfigMatch } from '../modules/taboola-common-frontend-modules/account-configurations';

export const useIsFeatureAllowedForICPAccount = featureFlagName => {
    const isAllowedAccount = useConfigMatch({ [featureFlagName]: 'true' });
    const isNotAllowedAccount = useConfigMatch({ [featureFlagName]: 'false' });
    const selectedAccount = useAccount();
    if (isAllowedAccount) {
        return true;
    }
    if (isNotAllowedAccount) {
        return false;
    }
    const accessRule = FEATURE_ACCESS_RULES[featureFlagName];

    return isFeatureAllowed(selectedAccount, accessRule);
};
